export const ru = {
    details: 'Подробности',
    passengers_count: {
        one: 'Цена за {count} пассажира',
        some: 'Цена за {count} пассажиров',
        many: 'Цена за {count} пассажиров',
    },
};
